import { render } from "./OrderChatHistory.vue?vue&type=template&id=5ee7dc99&scoped=true"
import script from "./OrderChatHistory.vue?vue&type=script&lang=js"
export * from "./OrderChatHistory.vue?vue&type=script&lang=js"

import "./OrderChatHistory.vue?vue&type=style&index=0&id=5ee7dc99&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee7dc99"]])

export default __exports__